import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { S25Util } from "../../../../util/s25-util";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { LangService } from "../../../../services/lang.service";
import { UserprefService } from "../../../../services/userpref.service";
import { jSith } from "../../../../util/jquery-replacement";
import { FreshbooksService } from "../../../../services/freshbooks.service";
import { S25ModalComponent } from "../../../s25-modal/s25.modal.component";
import { PricingOrgSummary } from "../s25-pricing-org-summary/s25.pricing.org.summary.component";
import { FBInvoice, FBInvoiceData, FBInvoiceDisplayData } from "../../../../pojo/Pricing";
import { Proto } from "../../../../pojo/Proto";
import NumericalBoolean = Proto.NumericalBoolean;

@TypeManagerDecorator("s25-ng-invoice")
@Component({
    selector: "s25-ng-invoice",
    template: `@if (init) {
        <div class="S25Invoice">
            <button class="c-textButton" [attr.aria-expanded]="viewExpanded" (click)="toggleView()">
                <s25-ng-collapse-chevron
                    aria-hidden="true"
                    [collapsedOrientation]="'right'"
                    [expanded]="viewExpanded"
                />
                FreshBooks
            </button>
            @if (viewExpanded) {
                @if (billId && showOrgSummary) {
                    <div class="summary-wrapper">
                        <s25-ng-pricing-org-summary
                            [modelBean]="freshbooksOrgSummary"
                            [freshbooksTab]="true"
                            [paymentsMode]="paymentsMode"
                            (signalScroll)="scrollSignal($event)"
                        ></s25-ng-pricing-org-summary>
                    </div>
                }
                <div>
                    @if (bean.showCreateInvoiceButton) {
                        <button
                            class="aw-button aw-button--outline c-margin-top--half c-margin-bottom--half c-margin-right--quarter"
                            (click)="createOrOverwriteInvoice()"
                        >
                            {{ invoiceLang.invoice_event }}
                        </button>
                    }
                    <s25-ng-modal #exportInvoiceModal [title]="invoiceLang.invoice_event" [size]="'xs'">
                        <ng-template #s25ModalBody>
                            <s25-ng-modal-invoice-freshbooks
                                [data]="newInvoiceData"
                                [invoiceLang]="invoiceLang"
                                (close)="exportInvoiceModal.close()"
                                (updateInvoiceData)="handleInvoiceUpdate()"
                            ></s25-ng-modal-invoice-freshbooks>
                        </ng-template>
                    </s25-ng-modal>
                    @if (bean.hasInvoices && !bean.showInvoices) {
                        <button
                            class="aw-button aw-button--primary c-margin-bottom--half c-margin-left--quarter"
                            (click)="getInvoiceInfo()"
                        >
                            Show Invoices
                        </button>
                    }
                    @if (bean.showInvoices) {
                        <div>
                            @if (bean.invoiceLoadError) {
                                <div>{{ bean.invoiceLoadError }}</div>
                            }
                            @for (invoice of bean.setInvoices; track invoice) {
                                <table class="tblInvoiceSummary" align="center">
                                    <tr>
                                        <td class="ngRightpadMed">
                                            <span><b>Invoice Created: </b></span>
                                            <span class="nowrap">{{ invoice?.date | dateFormat }}</span>
                                            <span class="ngRightpad">
                                                <a href="{{ invoice?.links.view }}">View</a>
                                            </span>
                                            <span>
                                                <a href="{{ invoice?.links.edit }}">Edit</a>
                                            </span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Invoice Number:</b><span> {{ invoice?.number }}</span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Status:</b><span> {{ invoice?.status }}</span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Paid:</b
                                            ><span> {{ $safeNavigationMigration(invoice?.paid) | currency }}</span>
                                        </td>
                                        <td>
                                            <b>Outstanding:</b
                                            ><span>
                                                {{
                                                    $safeNavigationMigration(invoice?.amount_outstanding) | currency
                                                }}</span
                                            >
                                        </td>
                                    </tr>
                                </table>
                            }
                            @if (showRelatedReminder) {
                                <div>{{ showRelatedReminder }}</div>
                            }
                            @for (invoice of bean.eventInvoices; track invoice) {
                                <table class="tblInvoiceSummary" align="center">
                                    <tr>
                                        <td class="ngRightpadMed">
                                            <span><b>Invoice Created:</b></span>
                                            <span class="nowrap">{{ invoice?.date | dateFormat }}</span>
                                            <span class="ngRightpad">
                                                <a href="{{ invoice?.links.view }}">View</a>
                                            </span>
                                            <span>
                                                <a href="{{ invoice?.links.edit }}">Edit</a>
                                            </span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Invoice Number:</b><span> {{ invoice?.number }}</span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Status:</b><span> {{ invoice?.status }}</span>
                                        </td>
                                        <td class="ngRightpadMed">
                                            <b>Paid:</b
                                            ><span> {{ $safeNavigationMigration(invoice?.paid) | currency }}</span>
                                        </td>
                                        <td>
                                            <b>Outstanding:</b
                                            ><span>
                                                {{
                                                    $safeNavigationMigration(invoice?.amount_outstanding) | currency
                                                }}</span
                                            >
                                        </td>
                                    </tr>
                                </table>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: `
        .S25Invoice .aw-button.aw-button--outline {
            background-color: #fff !important;
        }

        .S25Invoice .aw-button.aw-button--outline:focus,
        .S25Invoice .aw-button.aw-button--outline:hover {
            color: #fff !important;
            background-color: #3273a0 !important;
        }

        .S25Invoice .summary-wrapper {
            display: block;
            width: fit-content;
            margin: 1rem auto;
        }
    `,
    standalone: false,
})
export class S25InvoiceComponent implements OnInit {
    @Input() s25Invoices: FBInvoiceData;
    @Input() orgId: number;
    @Input() eventId: number;
    @Input() billId: number;
    @Input() isSetMode: boolean;
    @Input() hasRelatedEvents: boolean;
    @Input() freshbooksOrgSummary: PricingOrgSummary;
    @Input() paymentsMode: boolean;
    /** Off where the surrounding page already shows the org's totals and print controls. */
    @Input() showOrgSummary = true;

    @Output() refreshInvoices: EventEmitter<void> = new EventEmitter<void>();
    @Output() signalScroll: EventEmitter<string> = new EventEmitter<string>();

    @ViewChild("exportInvoiceModal") exportInvoiceModal: S25ModalComponent;

    init: boolean;
    invoiceLang: any;
    isSetModeBool: boolean;
    hasRelatedEventsBool: boolean;
    bean: FBInvoiceBean;
    showRelatedReminder: string;
    dateFormat: string;
    newInvoiceData: { billId: number; eventId: number; orgId: number; isSetMode: boolean };
    viewExpanded: boolean = false;

    constructor(private cd: ChangeDetectorRef) {}

    async ngOnInit() {
        this.isSetModeBool = !this.billId && S25Util.toBool(this.isSetMode);
        this.hasRelatedEventsBool = !this.billId && S25Util.toBool(this.hasRelatedEvents);

        this.bean = {
            showCreateInvoiceButton: true,
            showInvoiceSummary: true,
            showInvoices: false,
            hasInvoices: false,
        };

        if (this.hasRelatedEventsBool && !this.isSetModeBool) {
            this.showRelatedReminder =
                "This event has related events which can be invoiced together. Check 'Combine Related Events' above to see the pricing details for all of them.";
        }

        const [lang, dateFormat] = await Promise.all([LangService.getLang(), UserprefService.getS25Dateformat()]);

        this.invoiceLang = lang?.div.controls["s25-invoice"].text;
        this.invoiceLang.invoice_event = "Export Invoice"; //STORY-3142, STORY-2513
        this.dateFormat = dateFormat;

        const byOrgId = (inv: any) => inv.organization_id === this.orgId;

        this.bean.hasInvoices = (this.s25Invoices?.setInvoices?.filter(byOrgId).length ||
            this.s25Invoices?.eventInvoices?.filter(byOrgId).length ||
            this.s25Invoices?.customBillInvoices?.filter(byOrgId).length) as NumericalBoolean;

        this.init = true;
        this.cd.detectChanges();
    }

    async getInvoiceInfo() {
        this.bean.showInvoices = !!this.s25Invoices;
        this.bean.invoiceLoadError = undefined;
        const byOrgId = (inv: FBInvoice) => inv.organization_id === this.orgId;
        const setPromises: Promise<FBInvoiceDisplayData | null>[] = [];
        const eventPromises: Promise<FBInvoiceDisplayData | null>[] = [];

        //if in set mode, fetch invoice in this set and org; note: only 1 invoice should be in here since this is an exact set and org...
        this.isSetModeBool &&
            jSith.forEach(this.s25Invoices?.setInvoices?.filter(byOrgId), (_, inv) => {
                setPromises.push(this.loadInvoiceDisplay(inv));
            });

        //if not in set mode, fetch invoice in this event and org; note: only 1 invoice should be in here since this is an exact event and org...
        !this.isSetModeBool &&
            jSith.forEach(this.s25Invoices?.eventInvoices?.filter(byOrgId), (_, inv) => {
                eventPromises.push(this.loadInvoiceDisplay(inv));
            });

        this.billId &&
            jSith.forEach(this.s25Invoices?.customBillInvoices?.filter(byOrgId), (_, inv) => {
                eventPromises.push(this.loadInvoiceDisplay(inv));
            });

        this.bean.setInvoices = (await Promise.all(setPromises)).filter(Boolean) as FBInvoiceDisplayData[];
        this.bean.eventInvoices = (await Promise.all(eventPromises)).filter(Boolean) as FBInvoiceDisplayData[];

        this.cd.detectChanges();
    }

    private async loadInvoiceDisplay(inv: FBInvoice): Promise<FBInvoiceDisplayData | null> {
        try {
            return await FreshbooksService.getInvoice(String(inv.invoice_id), String(inv.instance_id));
        } catch (caughtError) {
            if (FreshbooksService.isFreshbooksNotFoundError(caughtError)) {
                this.bean.invoiceLoadError =
                    "This FreshBooks invoice could not be found. Export a new invoice if billing is still needed.";
                this.bean.hasInvoices = false;
                this.bean.showInvoices = false;
            } else {
                S25Util.showError(caughtError, "Failed to load FreshBooks invoice.");
            }
            return null;
        }
    }

    createOrOverwriteInvoice() {
        this.newInvoiceData = {
            billId: this.billId,
            eventId: this.eventId,
            orgId: this.orgId,
            isSetMode: this.isSetModeBool,
        };

        this.exportInvoiceModal.open();
    }

    handleInvoiceUpdate() {
        this.refreshInvoices.emit();
    }

    toggleView() {
        this.viewExpanded = !this.viewExpanded;
        this.cd.detectChanges();
    }

    scrollSignal(orgData: string) {
        this.signalScroll.emit(orgData);
    }
}

type FBInvoiceBean = {
    eventInvoices?: FBInvoiceDisplayData[];
    hasInvoices: NumericalBoolean | boolean;
    invoiceLoadError?: string;
    setInvoices?: FBInvoiceDisplayData[];
    showCreateInvoiceButton: boolean;
    showInvoices: boolean;
    showInvoiceSummary: boolean;
};
